import BadgeWithText from './BadgeWithText';

export default BadgeWithText;
